import IFACE, { EL } from './IFACE.js';
import Move, { DIRECTION } from '../event/Move.js';
/** An interface for Move driven Events */
export default class Movable extends IFACE {
    /** A series of Move Related Events and Methods */
    constructor(node) {
        super(node, 'movable');
    }
    addListeners(node) {
        node.on('move', (ev) => {
            const customEv = ev;
            if (customEv.detail.direction === DIRECTION.DOWN) {
                //this.onError(node.move, ev, 'MoveUp Failed');
                node.moveDown(node, customEv.detail.dur);
            }
            else {
                node.moveUp(node, customEv.detail.dur);
            }
        });
    }
    setMethods(node, dur = 150) {
        /** Moves the element up */
        this.methods.moveUp = () => this.move(node, DIRECTION.UP, dur);
        /** Moves the element down */
        this.methods.moveDown = () => this.move(node, DIRECTION.DOWN, dur);
    }
    /** Checks for the existence of a sibling to this node in the DOM, in the given direction
        @todo Eliminate JQuery dependency and instead use css animations and classes to indicate state
        @param {EL} node Element to implement methods
        @param {number} direction Move Direction (0=up,1=right,2=down,3=left)
        @returns {boolean} True if sibling exists
    */
    checkForSibling(node, direction) {
        console.log('debug: checkForSibling', node, direction);
        let hasSibling = false;
        switch (direction) {
            case DIRECTION.UP:
                //hasSibling = n.prev().length > 0;
                hasSibling = typeof node.getPrev() !== 'undefined';
                break;
            case DIRECTION.RIGHT:
            case DIRECTION.DOWN:
                //hasSibling = n.next().length > 0;
                hasSibling = typeof node.getNext() !== 'undefined';
                break;
            case DIRECTION.LEFT: // left
                break;
            default:
                console.warn(node.toString() + '.move(), No direction specified');
        }
        return hasSibling;
    }
    /** Moves this element in the specified direction amongst its siblings
        @param {EL} node Element to implement methods
        @param {number} direction Move Direction (0=up,1=right,2=down,3=left)
        @param {number} [dur] Animation duration in milliseconds
    */
    move(node, direction = DIRECTION.UP, dur = 150) {
        console.log('debug: move', node, direction, dur);
        console.log(node.toString() + '.moveUp(' + dur + ')');
        let nA = node;
        let hasSibling = this.checkForSibling(node, direction);
        if (hasSibling) {
            // Get next/prev sibling
            if (node.node instanceof HTMLElement) {
                console.warn('Movable.move: node.node is not an EL', node.node);
                throw new Error('Movable.move: node.node is not an EL');
            }
            let siblings = node.node.get();
            let myIndex = siblings.indexOf(node);
            let siblingIndex = direction === DIRECTION.UP ? myIndex - 1 : myIndex + 1;
            let sibling = siblings[siblingIndex];
            let nB = sibling;
            // Collapse element and sibling
            // [nA, nB].forEach((n) => n.animate({
            // 	height: 'toggle',
            // 	duration: dur
            // }));
            // Swap positions
            setTimeout(() => {
                // in the DOM...
                switch (direction) {
                    case 0:
                        nB.insertAfter(node);
                        break;
                    case 2:
                        nB.insertBefore(node);
                        break;
                    default:
                        console.warn('Unrecognized direction', direction);
                }
                // Swap positions in array too see https://stackoverflow.com/a/872317/722785
                let tmp = siblings[siblingIndex];
                siblings[siblingIndex] = siblings[myIndex];
                siblings[myIndex] = tmp;
                // Restore element and sibling
                // setTimeout(() => {
                // 	[nA, nB].forEach((n) => n.animate({
                // 		height: 'toggle',
                // 		duration: dur
                // 	}));
                // }, dur);
            }, dur);
        }
    }
}
export { EL, IFACE, Move };
